import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Flex, Spin, theme } from 'antd';

import { useGscSyncState } from './gsc-connection';
import SearchPerformanceDashboard from './SearchPerformanceDashboard';
import { SEARCH_PERFORMANCE_CONNECT_ROUTE } from './SearchPerformanceRoutes';

// The dashboard half of the route pair. A tenant with nothing synced has no
// dashboard to show, so it hands over to the connect flow rather than rendering
// the steps inline (PRE-3272). Connect forwards back only on an in-session sync
// completion (never a bare visit), and the two conditions are complementary on
// `hasSyncedConnection`, so the pair still cannot bounce. See
// `gsc-connection/AGENTS.md`.
function SearchPerformance() {
  const { token } = theme.useToken();
  const { search } = useLocation();
  const { isResolving, hasSyncedConnection, isBroken, lostUrls } = useGscSyncState();

  // Redirecting before the sync state is known would send returning users to
  // the connect flow for a frame.
  if (isResolving) {
    return (
      <Flex justify="center" style={{ paddingTop: token.paddingXL }}>
        <Spin />
      </Flex>
    );
  }

  const hasDataWorthShowing = hasSyncedConnection || isBroken || lostUrls.length > 0;

  // The query string rides along: `Navigate` drops it otherwise, which silently
  // strips anything deep-linked onto this route.
  if (!hasDataWorthShowing) {
    return <Navigate to={{ pathname: SEARCH_PERFORMANCE_CONNECT_ROUTE, search }} replace />;
  }

  return <SearchPerformanceDashboard />;
}

export default SearchPerformance;
